// 首页
import request from '@/utils/request'
import { getToken } from '@/utils/auth'

// 所有数据
export function findDeviceList(params) {
  if (!params.myToken) {
    return request({
      url: '/v3/report/findDeviceList',
      method: 'post',
      headers: { 'token': 'nmamtf' },
      data: params
    })
  } else {
    return request({
      url: '/v3/report/findDeviceList',
      method: 'post',
      data: params
    })
  }
}
export function sysDictInfo(params) { // 选择设备类型下拉框
  return request({
    url: 'v3/manager/sysDict/sysDictInfo',
    method: 'get',
    params: params
  })
}
export function deviceOnlineStatistic(params) { // 设备联网率
  return request({
    url: 'v3/report/deviceOnlineStatistic',
    method: 'post',
    data: params
  })
}
// 下拉框客户名称
export function listByCompanyParentId(params) {
  // if (!params.myToken) {
  //   return request({
  //     url: '/v3/company/listByCompanyParentId',
  //     method: 'post',
  //     headers: { 'token': 'nmamtf' },
  //     data: params
  //   })
  // } else {
  return request({
    url: 'v3/user/company/listByCompanyParentId',
    method: 'post',
    data: params
  })
  // }
}
// 添加设备--序列号下拉框
export function querySearchSn(params) {
  return request({
    url: 'v3/manager/device/querySearchBaseInfoSn?sn=' + params,
    method: 'post'
  })
}
// 添加设备--通过batteryId获取电池信息
export function deviceBattery(params) {
  return request({
    url: 'v3/manager/deviceBattery/get?id=' + params.id,
    method: 'get'
  })
}
// 添加设备--公司信息下拉框
export function getList(params) {
  return request({
    url: '/v3/user/company/list',
    method: 'post',
    data: params
  })
}
// 添加设备--电池型号下拉框
export function cascader() {
  return request({
    url: 'v3/manager/deviceBattery/cascader',
    method: 'post'
  })
}
// 添加设备--品牌下拉框
export function deviceMechcascader() {
  return request({
    url: 'v3/manager/deviceMech/cascader',
    method: 'get'
  })
}
// 添加设备--型号下拉框
export function machineTypeList() {
  return request({
    url: 'v3/manager/deviceMech/machineTypeList',
    method: 'get'
  })
}
export function updatePushSwitch(mcuId, on) { // 添加设备--通知推送
  var param = ''
  if (typeof (on) === 'undefined') {
    param = ''
  } else {
    param = '&on=' + on
  }
  return request({
    url: 'v2/deviceBindUser/updatePushSwitch?mcuId=' + mcuId + param,
    method: 'get'
  })
}
export function addDeviceBind(params) { // 添加设备--提交
  return request({
    url: 'v3/manager/addDeviceBind',
    method: 'post',
    data: params
  })
}
// 获取设置日志列表
export function apnList() {
  return request({
    url: '/v3/manager/configData/apnList',
    method: 'get'
  })
}
// 编辑设备信息弹窗--提交
export function updateDeviceBind(params) {
  return request({
    url: '/v3/manager/updateDeviceBind',
    method: 'post',
    data: params
  })
}
// 是否开启定位功能
export function findGeofenceDeviceList(params) {
  return request({
    url: '/v3/manager/geofence/findGeofenceDeviceList',
    method: 'get',
    data: params
  })
}
// 编辑设备重置时间弹窗--提交
export function addDeviceReset(params) {
  return request({
    url: '/v3/manager/addDeviceReset',
    method: 'post',
    data: params
  })
}// 编辑设备信息弹窗--恢复出厂设置
export function addDeviceAllReset(params) {
  return request({
    url: '/v3/manager/addDeviceAllReset',
    method: 'post',
    data: params
  })
}
// 设备信息
export function getDeviceInfoByMcuId(params) {
  return request({
    url: '/v3/report/getDeviceInfoByMcuId',
    method: 'post',
    data: params
  })
}
// 设备信息
export function getRealTimeInfo1(param) {
  return request({
    url: '/v3/openApi/internalAccess/getRealTimeInfo1/' + param.sn,
    method: 'get'
  })
}
// 设备信息
export function getRealTimeInfo2(param) {
  return request({
    url: '/v3/openApi/internalAccess/getRealTimeInfo2/' + param.sn,
    method: 'get'
    // params: param
  })
}
// 获取警告信息
export function warningListByMcuId(params) {
  return request({
    url: '/v3/report/warningListByMcuId',
    method: 'post',
    data: params
  })
}

// 获取设备最后的位置
export function getGNSSLastByMcuID(params) {
  return request({
    url: '/v3/location/getGNSSLastByMcuID',
    method: 'post',
    data: params
  })
}
export function getGnssConfig(params) {
  return request({
    url: '/v3/location/getGnssConfig',
    method: 'post',
    data: params

  })
}
export function updateGnssConfig(params) {
  return request({
    url: '/v3/location/updateGnssConfig',
    method: 'post',
    // headers: { 'token': 'nmamtf' },
    data: params

  })
}
// 设备版本号
export function getSettingsYHUB(param) {
  return request({
    url: '/v3/openApi/internalAccess/getSettingsYHUB/' + param.sn,
    method: 'get'
  })
}
// 设备基本信息
export function findDeviceInfo(params) {
  return request({
    url: '/v3/report/findDeviceInfo',
    method: 'post',
    data: params
  })
}
// 获取最后一条YhubConfig
export function getLastYhubConfig(params) {
  return request({
    url: '/v3/manager/yhubConfig/getLastYhubConfig',
    method: 'post',
    data: params
  })
}
// 获取锂电池信息
export function getLastOneMsgBMSData(params) {
  return request({
    url: '/v3/canbus/getLastOneMsgBMSData',
    method: 'post',
    data: params
  })
}
export function listMsgBMSData(params) {
  return request({
    url: '/v3/canbus/listMsgBMSData',
    method: 'post',
    data: params,
    responseType: 'arraybuffer'
  })
}
// 设备总数量、当前异常数、设备类型占比、当前异常--柱状图
export function findCompanyDeviceStatistic(params) {
  return request({
    url: '/v3/report/findCompanyDeviceStatistic',
    method: 'post',
    data: params
  })
}
export function getLastRealTimeData(param) {
  return request({
    url: '/v3/report/getLastRealTimeData?mcuId=' + param.mcuId,
    method: 'get',
    data: param
  })
}
// 锂电池详情页--allDeviceLithiumDetail
export function getLastBMSRecor(param) {
  return request({
    url: '/v3/canbus/bmsRecord/getLastBMSRecor?mcuId=' + param.mcuId,
    method: 'get'
  })
}
// 锂电池走势页--lithiumChartPage
export function listBMSRecor(params) {
  return request({
    url: '/v3/canbus/bmsRecord/listBMSRecor',
    method: 'post',
    data: params,
    responseType: 'arraybuffer'
  })
}
// 锂电池走势页--lithiumChartPage
export function deviceStatistic(param) {
  return request({
    url: '/v3/report/deviceStatistic?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate,
    method: 'get'
  })
}
// v4
// yhub列表
export function findBatteryDeviceList(params) {
  return request({
    url: '/v3/report/findBatteryDeviceList',
    method: 'post',
    data: params
  })
}
// yhub列表
export function findBatteryDeviceListV3(params) {
  return request({
    url: '/v3/report/findBatteryDeviceListV3',
    method: 'post',
    data: params
  })
}
// lithium列表
export function findLithiumDeviceList(params) {
  return request({
    url: '/v3/report/findLithiumDeviceList',
    method: 'post',
    data: params
  })
}
// controller列表
export function findControllerDeviceList(params) {
  return request({
    url: '/v3/report/findControllerDeviceList',
    method: 'post',
    data: params
  })
}
// 惠州亿纬锂能列表
export function findLithiumEVDeviceList(params) {
  return request({
    url: '/v3/report/findLithiumEVDeviceList',
    method: 'post',
    data: params
  })
}
// eveF477列表
export function findLithiumEV477DeviceList(params) {
  return request({
    url: '/v3/report/findLithiumEV477DeviceList',
    method: 'post',
    data: params
  })
}
// 惠州亿纬锂能下载
export function exportMsgEVbmsData(params) {
  return request({
    url: '/v3/report/exportMsgEVbmsData?endDate=' + params.endDate + '&mcuId=' + params.mcuId + '&showAll=false' + '&startDate=' + params.startDate,
    method: 'get'
  })
}
//  判断当前登陆人所有设备对应的类型--判断有哪些类型有设备
export function findDeviceType(param) {
  return request({
    url: '/v3/report/findDeviceType',
    method: 'get'
  })
}
//  添加设备--设备版本号
export function getLastMessageBootReq(param) {
  return request({
    url: '/v3/manager/configData/getLastMessageBootReq?mcuId=' + param.mcuId,
    method: 'get'
  })
}
// 设备解绑
export function deleteDeviceBind(params) {
  return request({
    url: '/v3/manager/deleteDeviceBind',
    method: 'post',
    data: params
  })
}
// 查询sn绑定状态信息
export function querySN(params) {
  return request({
    url: '/v3/manager/device/querySN?sn=' + params.sn,
    method: 'post',
    data: params
  })
}
// 绑定设备基础信息
export function addDeviceBindBase(params) {
  return request({
    url: '/v3/manager/addDeviceBindBase',
    method: 'post',
    data: params
  })
}
// 绑定设备基础信息config
export function addDeviceBindConfig(params) {
  return request({
    url: '/v3/manager/addDeviceBindConfig',
    method: 'post',
    data: params
  })
}
// 修改设备基础信息
export function updateDeviceBindBase(params) {
  return request({
    url: '/v3/manager/updateDeviceBindBase',
    method: 'post',
    data: params
  })
}
// 获取基础信息
export function getLastOne(params) {
  return request({
    url: '/v3/manager/configData/getLastOne',
    method: 'post',
    data: params
  })
}
// soc详情页
// 获取放电数据--yhub
export function listDischarging(params) {
  return request({
    url: '/v3/report/chargingDischarging/listDischarging',
    method: 'post',
    data: params
  })
}
// 获取放电数据--锂电池
export function bmsListDischarging(params) {
  return request({
    url: '/v3/report/bms/chargingDischarging/listDischarging',
    method: 'post',
    data: params
  })
}
// 获取放电数据--yhub
export function listCharging(params) {
  return request({
    url: '/v3/report/chargingDischarging/listCharging',
    method: 'post',
    data: params
  })
}
// 获取放电数据--锂电池
export function bmsListCharging(params) {
  return request({
    url: '/v3/report/bms/chargingDischarging/listCharging',
    method: 'post',
    data: params
  })
}
// 获取sim数据
export function getSim263TableByMcuId(params) {
  return request({
    url: '/v3/manager/iot263/getSim263TableByMcuId?mcuId=' + params.mcuId,
    method: 'get'
  })
}

export function download263() {
  var url = process.env.VUE_APP_BASE_API + '/v3/report/sim263Statistics/exportSim263Statistics?token=' + getToken()
  window.open(url, '_bank')
}
// 获取设置日志列表
export function listDeviceLog(params) {
  return request({
    url: '/v3/manager/listDeviceLog?mcuId=' + params.mcuId,
    method: 'get'
  })
}
// 新增设置日志
export function addDeviceLog(params) {
  return request({
    url: '/v3/manager/addDeviceLog',
    method: 'post',
    data: params
  })
}
// 获取总工作时长、总使用时长
export function getHourMeterTotalTime(params) {
  return request({
    url: '/v3/report/getHourMeterTotalTime?mcuId=' + params.mcuId,
    method: 'get'
  })
}
// 获取实时数据
export function getLastRecordData(params) {
  return request({
    url: '/v3/report/getLastRecordData?mcuId=' + params.mcuId,
    method: 'get'
  })
}
// 校验提交
export function yhubControl(params) {
  return request({
    url: '/v3/manager/yhubRemote/yhubControl',
    method: 'post',
    data: params
  })
}
// 获取yhub所属公司下的城市/站点列表
export function getCompanySiteList(params) {
  return request({
    url: '/v3/manager/getCompanySiteList',
    method: 'get'
  })
}
// 获取最后一条EnerdriverData
export function lastEnerdriverData(params) {
  return request({
    url: '/v3/report/lastEnerdriverData?mcuId=' + params.mcuId,
    method: 'get'
  })
}
// 获取最后一条eveF477
export function lastMsgFP477Data(params) {
  return request({
    url: '/v3/report/lastMsgFP477Data?mcuId=' + params.mcuId,
    method: 'get'
  })
}
// 获取全部的can功能
export function canFunctionList() {
  return request({
    url: '/v3/manager/configData/canFunctionList',
    method: 'get'
  })
}
// 获取车辆维护信息
export function getVehicleMaintenanceMsg(params) {
  return request({
    url: '/v3/manager/getVehicleMaintenanceMsg?mcuId=' + params,
    method: 'post'
  })
}
// 电池维护信息：
export function getBatteryMaintenanceMsg(params) {
  return request({
    url: '/v3/manager/getBatteryMaintenanceMsg?mcuId=' + params,
    method: 'post'
  })
}
// 电池长时间未使用信息：
export function getBatteryLongNoUseMsg(params) {
  return request({
    url: '/v3/manager/getBatteryLongNoUseMsg?mcuId=' + params,
    method: 'post'
  })
}
// 获取车辆维护信息
export function getDataServiceMsg(params) {
  return request({
    url: '/v3/manager/getDataServiceMsg?mcuId=' + params,
    method: 'post'
  })
}
// 车辆保养处理
export function handleVehicleMaintenanceMsg(params) {
  return request({
    url: '/v3/manager/device/handleVehicleMaintenanceMsg',
    method: 'post',
    data: params
  })
}
// 获取设备信息
export function getBaseYhubInfoBySn(params) {
  return request({
    url: '/v3/manager/baseYhubInfo/getBaseYhubInfoBySn?sn=' + params.sn,
    method: 'get',
    data: params
  })
}
